package com.klantenstop.web.pages.authentication.forgotPassword

import com.materialkobweb.components.toast.ToastManager
import com.klantenstop.web.data.repos.AuthRepo
import com.materialkobweb.utils.ViewModel
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class ForgotPasswordViewModel(
    email: String,
    private val authRepo: AuthRepo = AuthRepo,
) : ViewModel(), ForgotPasswordContract {

    private val _state = MutableStateFlow(ForgotPasswordContract.State(email))
    override val state = _state.asStateFlow()

    private val _effect = MutableSharedFlow<ForgotPasswordContract.Effect>()
    override val effect = _effect.asSharedFlow()

    override fun sendIntent(intent: ForgotPasswordContract.Intent) = coroutineScope.launch {
        when (intent) {
            is ForgotPasswordContract.Intent.SubmitForgotPassword -> submitForgotPassword()
            is ForgotPasswordContract.Intent.UpdateEmail -> updateState { it.copy(emailAddress = intent.value) }
        }
    }

    private suspend fun submitForgotPassword() {
        val email = _state.value.emailAddress

        updateState { it.copy(showValidation = true) }

        if (email.isEmpty()) {
            ToastManager.warning("Vul een e-mailadres in", title = "Ongeldige invoer")
            return
        }

        updateState { it.copy(isLoading = true) }

        try {
            authRepo.forgotPassword(email)
            updateState { it.copy(isLoading = false) }
            ToastManager.success(
                "We hebben je een e-mail gestuurd met instructies om je wachtwoord te resetten.",
                title = "E-mail verzonden"
            )
        } catch (e: Exception) {
            updateState { it.copy(isLoading = false) }
            ToastManager.error(
                e.message ?: "Er is iets misgegaan. Probeer het later opnieuw.",
                title = "Fout"
            )
        }
    }

    override fun emitEffect(effect: ForgotPasswordContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (ForgotPasswordContract.State) -> ForgotPasswordContract.State) {
        _state.update(block)
    }
}

